export const ProjectData = [

    {
        id:1,
        title:"Personal PortFolio",
        about:"A lightweight, single-page responsive personal portfolio/website built using ReactJs that showcase Projects, Skills, Professional Experience and Contact.",
        tags:["ReactJS","NodeJS"],
        demo:"https://fascinating-syrniki-a00d42.netlify.app/",
        github:"https://github.com/adityaroshanpatro/Portfolio",
        image:"https://www.inkyy.com/wp-content/uploads/2019/08/prew2.png",
    },
    {
        id:1,
        title:"MicroEntreprenuer Application",
        about:"An Ecommerce Product that used Supplychain management and inventory menagemnt to deliver retailers with their goods and let them manage their personal inventory",
        tags:["ReactJS","Django","Postgresql","Postman","Python","Git"],
        // demo:"",
        // github:"",
        image:"",
    },
    {
        id:1,
        title:"Co-flow Jet on Airfoil - Boundary Layer Separation",
        about:"2D simulations of a Airfoil with a co-flow jet to control the turbulent layer separation phenomenon and delay it at high angle of attacks (>30 )by conducting simulations on ANSYS Fluent. CFJ was able to increase the lift parameters significantly and increase stall angle by 5 degrees",
        tags:["Fluid Mechanics","Soliworks","ANSYS","Fluent"],
        // demo:"",
        // github:"",
        image:"https://s3-eu-west-1.amazonaws.com/fetchcfd/original/file-1482937691660.jpg",
    },
    {
        id:1,
        title:"Design and Simulation of MEMS based Microhotplate as Gas Sensor - MEMS",
        about:"MEMS based Micro Hotplates in gas sensing applications. I worked on the simulation of a MEMS micro-hotplate. The electro-thermo-mechanical behaviors of micro- hotplates (MHP) have been simulated using COMSOL Multiphysics.",
        tags:["COMSOL Multiphysics","ANSYS","SolidWorks"],
        // demo:"",
        // github:"",
        image:"https://cdn.comsol.com/products/mems/electrostatically_550x450.png",
    },
];